import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'

import CircularProgress from '@material-ui/core/CircularProgress'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import InfoIcon from '@material-ui/icons/Info'

import StepLabel from '@material-ui/core/StepLabel'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Store from '../data/Store'
import routes from '../routes'

import coolfrontLogo from '../images/coolfront_logo.png'
import fieldedgeLogo from '../images/fieldedge_flatrate_by_coolfront_logo.png'


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    height: '1em',
    margin: `0 4px -4px`,
  },
  fieldEdgeLogo: {
    height: '2em',
    margin: `0 ${theme.spacing.unit}px`,
  },
  readOnlyModal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    textAlign: 'center',
    padding: 8,
    zIndex: 1301, // Just enough to get above MaterialUI's modal dialog ;)
    opacity: 0.2,
    fontSize: '1.4em',
    backgroundColor: 'yellow',
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  stepLabel: {
    display: 'none',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  snackbar: {
    marginTop: theme.spacing.unit * 3,
  },
  snackbarErrorContent: {
    backgroundColor: theme.palette.error.dark,
    flexGrow: 0,
    flexWrap: 'nowrap',
  },
  snackbarErrorIcon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  snackbarErrorMessage: {
    display: 'flex',
    alignItems: 'center',
  },
})



let store = null


const SMALL_SCREEN_WIDTH = 600
function screenIsNarrow () {
  return window.innerWidth <= SMALL_SCREEN_WIDTH
}


class Signup extends React.Component {

  state = {
    smallScreen: screenIsNarrow(),
  }


  constructor() {
    super()
    store = new Store(this.triggerRender)
  }


  componentDidMount = () => {
    this._isMounted = true
    window.addEventListener("resize", this.checkScreenSize)
  }


  componentWillUnmount = () => {
    this._isMounted = false
    window.removeEventListener("resize", this.checkScreenSize)
  }


  // Set the state each time a render is requested, otherwise two quick render
  // calls would only a single rerendering
  triggerRender = () => {
    if (!this._isMounted) return
    this.setState({lastRender: +new Date()})
  }


  // NOTE: We could have used the `withMobileDialog` wrapper to automatically
  // switch the Dialog to fullscreen, but we also needed to know about small
  // screens so the BookConfig could switch to MobileStepper, and so the
  // labels on the main stepper could be hidden on mobile devices.

  checkScreenSize = () => {
    const smallScreen = screenIsNarrow()
    if (this.state.smallScreen !== smallScreen) {
      this.setState({smallScreen})
    }
  }


  getStepContent = (path) => {
    var i = routes.indexForPath(path)
    if (i < 0) {
      console.error('Cannot render unknown path: ' + path)
      return
    }
    const props = {
      data:         store.state,
      actions:      store.actions,
      showErrors:   store.state.showErrors,
      smallScreen:  this.state.smallScreen,
    }
    return React.createElement(routes.get(i).content, props, null)
  }


  closeSnackbar = () => {
    store.actions.hideTopLevelError()
  }


  handleNext = () => {
    store.actions.gotoNextPage()
  }


  handleBack = () => {
    store.actions.gotoPrevPage()
  }


  handleReset = () => {
    this.setState({ activeStep: 0, })
  }


  render = () => {
    const { classes } = this.props
    const { state, actions } = store

    if (!state) return null

    const {
      toggleAdminMode,
      resetDemo,
      startNewOrder,
      placeOrder,
    } = actions

    const {
      brand,
      path,
      canOrderWithoutPayment,
      orderStatus,
      loading,
      adminMode,
      topLevelError,
      pageErrorCount,
      readOnly,
      pricingMode,
    } = state

    const activeStep = routes.indexForPath(path)
    const showFakePlaceOrderButton = canOrderWithoutPayment
    const showNextButton = (path !== '/order')
    const showNavButtons = !orderStatus || orderStatus === 'active'

    const fieldEdgeBranded = brand === 'fieldedge'
    const logoSrc       = fieldEdgeBranded ? fieldedgeLogo:                   coolfrontLogo
    const logoAlt       = fieldEdgeBranded ? 'FieldEdge Logo':                'Coolfront Logo'
    const logoClass     = fieldEdgeBranded ? classes.fieldEdgeLogo:           classes.logo
    const appTitle      = fieldEdgeBranded ? '': /* just the logo*/           'Coolfront Books Signup'
    const supportEmail  = fieldEdgeBranded ? 'support@fieldedge.zendesk.com': 'support@coolfront.com'
    const copyrightName = fieldEdgeBranded ? 'FieldEdge':                     'Coolfront'
    const supportPhone  = fieldEdgeBranded ? '800-226-7529':                  '888-229-4100'

    return (
      <React.Fragment>
        <CssBaseline />
        {
          readOnly
          ? (
            <div className={classes.readOnlyModal}>
              <Typography variant="h5">READ ONLY MODE</Typography>
            </div>
          )
          : null
        }

        <main className={classes.layout}>

          <Paper className={classes.paper}>
            {
              adminMode
              ? (
                <Grid container alignItems="center">
                  <Grid item xs={12} sm={6} style={{padding:8}}>
                    <Button fullWidth onClick={startNewOrder} variant="outlined">Start a New Order</Button>
                  </Grid>
                  <Grid item xs={12} sm={6} style={{padding:8}}>
                    <Button fullWidth onClick={resetDemo} variant="outlined">Create a Demo Order</Button>
                  </Grid>
                </Grid>
              )
              : null
            }

            <Typography className={classes.heading} component="h1" variant="h5" align="center">
              {
                brand
                ? <div>
                    <img src={logoSrc} alt={logoAlt} className={logoClass} onContextMenu={e => {e.preventDefault(); toggleAdminMode()}} onDoubleClick={startNewOrder}/>
                    &nbsp;
                    {appTitle}
                  </div>
                : null
              }
            </Typography>
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {routes.all().map(r => (
                <Step key={r.name}>
                  <StepLabel classes={{labelContainer: classes.stepLabel}}>{r.name}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {

                loading ? (
                  <React.Fragment>
                    <div style={{display:'flex', alignItems: 'center', justifyContent: 'center', margin: '100px auto'}}>
                      <CircularProgress className={classes.progress} style={{marginRight: 20}}/>
                      <Typography variant="h6" component="div">
                        Loading...
                      </Typography>
                    </div>
                  </React.Fragment>
                )

                : orderStatus === 'processing' ? (
                  <React.Fragment>
                    <div style={{display:'flex', alignItems: 'center', justifyContent: 'center', margin: '100px auto'}}>
                      <CircularProgress className={classes.progress} style={{marginRight: 20}}/>
                      <Typography variant="h6" component="div">
                        Processing...
                      </Typography>
                    </div>
                  </React.Fragment>
                )

                : orderStatus === 'error' ? (
                  <React.Fragment>
                    <Typography variant="h5" gutterBottom>
                      Uh Oh
                    </Typography>
                    <br/>
                    <Typography variant="subtitle1">
                      There was an unexpected problem processing your order.
                    </Typography>
                    <br/>
                    <Typography variant="body1">
                      {/* Please use our live chat or call our toll-free number 888-229-4100 and choose option 1 (for customer support). */}
                      Please call our toll-free number 888-229-4100 and choose option 1 (for customer support).
                    </Typography>
                  </React.Fragment>
                )

                : orderStatus === 'cancelled' ? (
                  <React.Fragment>
                    <Typography variant="h5" gutterBottom>
                      Sorry
                    </Typography>
                    <br/>
                    <Typography variant="subtitle1">
                      This order has been cancelled.
                    </Typography>
                    <br/>
                    <Typography variant="body1">
                      {/* Please use our live chat or call our toll-free number 888-229-4100 and choose option 1 (for customer support). */}
                      Please call our toll-free number 888-229-4100 and choose option 1 (for customer support).
                    </Typography>
                    <br/>
                    <Typography variant="body1">
                      <Button onClick={startNewOrder} variant="outlined" color="primary">Start a New Order</Button>
                    </Typography>
                  </React.Fragment>
                )

                : orderStatus === 'completed' ? (
                  <React.Fragment>
                    <Typography variant="h5" gutterBottom>
                      Thank you.
                    </Typography>
                    <br/>
                    <Typography variant="subtitle1">
                      Your order has been processed.
                    </Typography>
                    <br/>
                    <Typography variant="body1">
                      You will receive an email with directions for accessing your new account.
                    </Typography>
                    <br/>
                    {
                      (pricingMode === 'Safe')
                      ? <Typography variant="body1">
                          If you are interested in ordering printed books, please contact us
                          at <a href="mailto:support@coolfront.com">support@coolfront.com</a> or 888-229-4100.
                        </Typography>
                      : null
                    }
                  </React.Fragment>
                )

                : (
                  <React.Fragment>
                    {path && this.getStepContent(path)}
                  </React.Fragment>
                )

              }
            </React.Fragment>
            {
              showNavButtons
              ? (
                  <div className={classes.buttons}>
                  {activeStep !== 0 && (
                    <Button onClick={this.handleBack} className={classes.button}>
                      Back
                    </Button>
                  )}
                  {
                    showFakePlaceOrderButton
                    ? (
                      <Button
                        id="place-order"
                        key="place-order"
                        variant="contained"
                        color="primary"
                        onClick={placeOrder}
                        className={classes.button}
                      >
                        Place Order
                      </Button>
                    )
                    : null
                  }
                  {
                    showNextButton
                    ? (
                      <Button
                        id="next-button"
                        key="next-button"
                        variant={pageErrorCount ? 'outlined' : 'contained'}
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      >
                        Next
                      </Button>
                    )
                    : null
                  }

                </div>
              )
              : (
                null
              )
            }
          </Paper>

          <div style={{color:'#999', fontFamily:'Roboto', margin:'auto', textAlign:'center', fontSize:'90%'}}>
            <span>Should you have any questions, please email us at <a href={'mailto:' + supportEmail}>{supportEmail}</a> </span>
            <span>or call (toll free) {supportPhone}</span>
            <br/>
            <br/>
            <span style={{fontSize:'90%', color:'#aaa'}}>©{new Date().getUTCFullYear()} {copyrightName}</span>
            <br/>
            <br/>
            <br/>
          </div>

        </main>

        <Snackbar
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          className={classes.snackbar}
          open={!!topLevelError}
          variant="info"
          // autoHideDuration={9000}
          onClose={this.closeSnackbar}
          onExited={this.closeSnackbar}
        >
          <SnackbarContent
            className={classes.snackbarErrorContent}
            message={
              <span id="message-id" className={classes.snackbarErrorMessage}>
                <InfoIcon className={classes.snackbarErrorIcon} />
                {topLevelError && topLevelError.split('\n').join(', ')}
              </span>
            }
            aria-describedby="message-id"
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.closeSnackbar}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </Snackbar>
      </React.Fragment>
    )
  }
}

Signup.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Signup)